export const getSetting = () => {
    const setting = localStorage.getItem('setting');
    if (setting) {
        return JSON.parse(setting);
    } else {
        return { lang: 'fa' };
    }
};
export const getSettingItem = (item) => {
    const setting = getSetting();
    if (setting) {
        return setting[item];
    }
};

export const setSettingItem = (item, value) => {
    let setting = getSetting();
    if (setting) {
        setting = { ...setting, [item]: value };
    } else {
        setting = { [item]: value };
    }
    localStorage.setItem('setting', JSON.stringify(setting));
};

export const getNamespace = () => {
    const workspace = localStorage.getItem('workspace');
    if (!workspace) {
        return;
    }
    return JSON.parse(workspace)?.polyclinic?.id;
};
export const getClinicId = () => {
    const workspace = localStorage.getItem('workspace');
    if (!workspace) {
        return;
    }
    return JSON.parse(workspace)?.clinic?.id;
};
export const getClinicStartTime = () => {
    return JSON.parse(localStorage.getItem('workspace'))?.clinic?.start_time;
};
export const getClinicTimeZone = () => {
    const workspace = JSON.parse(localStorage.getItem('workspace'));
    const timezone = workspace?.clinic?.start_tz;
    if (!workspace || !timezone) {
        return 'Asia/Tehran';
    }
    return timezone;
};
export const getAccessToken = () => {
    const data = localStorage.getItem('clinic-data');
    if (data) {
        const parsed = JSON.parse(data);
        const access = parsed.access;
        return access;
    }
};
export const getRefreshToken = () => {
    const data = localStorage.getItem('clinic-data');
    if (data) {
        const parsed = JSON.parse(data);
        const refresh = parsed.refresh;
        return refresh;
    }
};
export const setAuthData = (access, refresh) => {
    const authData = {
        access,
        refresh
    };
    localStorage.setItem('clinic-data', JSON.stringify(authData));
};
export const setUserWorkspace = (workspace) => {
    if (workspace) {
        localStorage.setItem('workspace', JSON.stringify(workspace));
    }
};
export const getWorkspace = () => {
    const workspace = localStorage.getItem('workspace');
    if (!workspace) {
        return;
    }
    return JSON.parse(workspace);
};
export const deleteWorkspace = () => {
    localStorage.removeItem('workspace');
};
